export async function getList({commit}) {
  const response = await this.$adminRepositories.provinces.index();
  const {errResponse, data: responseData} = response;
  if (errResponse || !responseData.success) {
    return commit('setList', []);
  }

  commit('setList', responseData.data);
}